__turbopack_context__.v({
  "className": "great_vibes_8b47f573-module__em2j-G__className",
  "variable": "great_vibes_8b47f573-module__em2j-G__variable",
});
